import React from 'react'

const CrossIcon = props => (
  <svg width={18} height={20} fill="none" {...props}>
    <path
      d="M17.75 11.372h-7.5v7.834h-2.5v-7.834H.25v-2.61h7.5V.927h2.5V8.76h7.5v2.611z"
      fill="#004360"
    />
  </svg>
)

export default CrossIcon
